import { policyConfig } from "shared";

import { fieldIsValid } from "../../../../../lib/helper";
import { Toggle } from "../../../../../../common/Atoms/Toggle";

import { IFieldProps } from "./fieldProps";

export function WebhookDisabled({
  policyFormData,
  invalids,
  handleChange,
}: IFieldProps) {
  const label = policyConfig.webhook_disabled?.label;

  return (
    <Toggle
      label={ label }
      helpIcon={ `Skip webhook sending for this policy, configure webhooks in advanced settings.` }
      checked={ policyFormData.webhook_disabled || false }
      onChange={ handleChange }
      name={ `webhook_disabled` }
      description={ `Never send a webhook for this policy.` }
      invalid={ fieldIsValid(`webhook_disabled`, invalids) }
    />
  );
}
